// Legacy browser cache is optional. Redux owns selection, including an explicit
// clear; do not read this cache again after initialization in the same store.
export function readDeliveryAddress() {
  try {
    return JSON.parse(localStorage.getItem('deliver_address') || 'null');
  } catch {
    return undefined;
  }
}

export function persistDeliveryAddress(address) {
  try {
    if (address) {
      localStorage.setItem('deliver_address', JSON.stringify(address));
    } else {
      localStorage.removeItem('deliver_address');
    }
  } catch {
    // Quota, access and serialization failures must not reject active state.
  }
}
